import { Box } from '@mui/material';
import { concat, get } from 'lodash';
import React, { FC, useMemo } from 'react';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import MUIDownloadFile from '../../../../../../../components/ui-component/form-component/form-fields/fields/MUIDownloadFile';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { getUserJwt } from '../../../../../../../context/AuthHelper';
import { ANTRAGS_STATUS, PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { STRAPI_URL } from '../../../../../../../lib/constants/url';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import AntragSchema from '../../../../../../../lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const Bescheid: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	const bescheidPath = P.Zuwendungsvertarg_Unterschriebener_Vertrag_VDMK.path;
	const bescheidDownloadOnPath = P.Zuwendungsvertarg_Unterschrieben_Am.path;

	const handleDownloadBescheid = async () => {
		await fetchFile(get(application, `${bescheidPath}.attributes.url`), get(application, `${bescheidPath}.attributes.name`));
	};

	const isUploadFieldDisabled = useMemo(() => {
		if (
			get(application, P.Status_Status.path) === ANTRAGS_STATUS.vertragUebermittel &&
			!get(application, P.Zuwendungsvertarg_Unterschrieben_Am.path, '')
		) {
			return false;
		} else {
			return readOnly;
		}
	}, [application, readOnly]);

	return (
		<>
			<ApplicationHeading title='Bescheid' description={PLATZHALTER_TEXT} />

			<MUIDownloadFile
				fileMetaData={get(application, bescheidPath, {})}
				onDownload={handleDownloadBescheid}
				downloadedOn={get(application, bescheidDownloadOnPath, null)}
				showDownloadButton={true}
				showDownloadedOn={false}
			/>

			<Box sx={{ mt: '2rem' }}></Box>

			<CreateForm
				formStruc={formStruc()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={isUploadFieldDisabled}
			/>
		</>
	);
};

export default Bescheid;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Zuwendungsvertarg_Unterschriebener_Vertrag_MKS,
					label: 'Bitte laden Sie hier den unterschriebenen Bescheid hoch:',
				}

			],
		},
	];
	return struc;
};

export const getFormStrucBescheid = () => {
	return concat(formStruc());
};
const fetchFile = async (url: string, fileName: string = '') => {
	try {
		let res = await fetch(`${STRAPI_URL}${url}`, {
			headers: {
				Authorization: `Bearer ${getUserJwt()}`,
			},
		});

		const blob = await res.blob();
		const objectUrl = URL.createObjectURL(blob);

		const link = document.createElement('a');
		link.href = objectUrl;
		link.download = fileName;
		document.body.appendChild(link);
		link.click();
		link.remove();
		URL.revokeObjectURL(objectUrl);
	} catch (err: any) {
		console.error(' ERROR: Downloading File ', err);
	}
};
